import { Link } from "react-router-dom";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Box,
  Typography,
} from "@mui/material";
import RestoreIcon from "@mui/icons-material/Restore";
import { ShopShirtInterface } from "../../services/shirts/types";
import DefaultShirt from "../../img/defaultShirt.png";

interface ShopSquareViewProps {
  shirt: ShopShirtInterface;
}

const ShopSquareView = ({ shirt }: ShopSquareViewProps) => {
  return (
    <Card sx={{ width: "100%", borderRadius: "10px" }}>
      <Link to={shirt.url} target="_blank" style={{ display: "block" }}>
        <CardActionArea>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: { xs: 350, sm: 300 },
              padding: "1rem 1rem 0rem 1rem",
            }}
          >
            <CardMedia
              component="img"
              image={
                shirt.images.length > 0
                  ? shirt.images[0].url
                    ? shirt.images[0].url
                    : DefaultShirt
                  : DefaultShirt
              }
              alt={shirt.name ? shirt.name : shirt.original_name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "50% 50%",
                borderRadius: "5px",
              }}
            />
          </Box>
          <CardContent sx={{ height: 150 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: 0.5,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#4663ff",
                      fontWeight: "700",
                      textTransform: "capitalize",
                      fontSize: "0.85rem !important",
                    }}
                  >
                    {shirt.shop.name}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography sx={{ color: "#4663ff", fontWeight: "700" }}>
                    €{shirt.price}
                  </Typography>
                </Box>

                {shirt.sold && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "end",
                      alignItems: "center",
                      flex: 1,
                    }}
                  >
                    <Box sx={{ marginRight: "5px" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#3c3c40",
                          fontWeight: "500",
                          textTransform: "capitalize",
                          fontSize: "0.5rem !important",
                        }}
                      >
                        <RestoreIcon />
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#3c3c40",
                          fontWeight: "500",
                          textTransform: "capitalize",
                          fontSize: "0.75rem !important",
                        }}
                      >
                        Ended
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>

              <Box
                sx={{ display: "flex", flexDirection: "column", rowGap: 0.5 }}
              >
                <Box>
                  <Typography
                    sx={{
                      color: "#3c3c40",
                      fontWeight: "700",
                      fontSize: "1rem !important",
                    }}
                  >
                    {shirt.name}
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              ></Box>
            </Box>
          </CardContent>
        </CardActionArea>
      </Link>
    </Card>
  );
};

export default ShopSquareView;
